<template>
    <div class="ur-data-grid__content__select-wrapper" ref="selectWrapper">
        <div class="ur-data-grid__content__select-holder" :style="holderStyle">
            <!-- SELECT-GUIDE -->
            <div class="ur-data-grid__content__select-guide" v-if="isSelected" 
                    :style="selectStyle" :class="selectClass">
                <div class="ur-data-grid__content__select-highlight-wrapper">
                    <div class="ur-data-grid__content__select-highlight"  :style="firstStyle"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name : 'urDataGridContentCellSelect',
    inject : ['gridInfo'],
    data() {return {
        recomputed : null
    }},
    props : {
        height: {type:Number}
    },
    computed : {
        // [COMPUTED] Flag, isSelected
        isSelected() {
            return this.gridInfo.vars_cSelOnSelect
        },
        // [COMPUTED] Style, Holder style
        holderStyle() {
            return {height:this.height+'px'}
        },
        // [COMPUTED] Style, Select class
        selectClass() {
            var clazz = [];
            if(!this.gridInfo.vars_cSelOnEdit) {
                clazz.push('ur-data-grid__content__select-guide--animation');
            }
            if(this.gridInfo.vars_cClipboard) {
                clazz.push('ur-data-grid__content__select-guide--on-copy');
            }
            return clazz;
        },
        // [COMPUTED] Style, Sub, Calculate vertical value
        verticalStyle() {
            var style = {};
            const h   = this.gridInfo.opts.rowHeight
                , stTop  = this.gridInfo.vars_cSelIdxSt < this.gridInfo.vars_cSelIdxEd
                , minIdx = stTop ? this.gridInfo.vars_cSelIdxSt : this.gridInfo.vars_cSelIdxEd
                , maxIdx = stTop ? this.gridInfo.vars_cSelIdxEd : this.gridInfo.vars_cSelIdxSt;
            const borderOffset = this.gridInfo.opts.styleBordered?1:0;
            style.top    = minIdx*h + "px";
            style.height = ((maxIdx - minIdx+1)*h-borderOffset) + "px";
            return style;
        },
        // [COMPUTED] Style, Sub, Calculate horizontal value
        /* NOSONAR */horizontalStyle() {
            /*update flag*/this.recomputed;
            var style = {};
            // 1. Prepare value
            // 1.0 Default values
            const $src = this.gridInfo.refs.scrollWrapper;
            const COLS = this.gridInfo.cols;
            const FRZ  = this.gridInfo.vars_freezeWidth,
                  SRW  = $src.getBoundingClientRect().width,
                  SCL  = $src.scrollLeft;
            const dWIDTH = this.gridInfo.opts.defaultFieldWidth;
            // 1.1 isScroll?
            const isScroll = SRW+FRZ < this.gridInfo.vars_tableWidth;
            // 2. Calc st/ed postions.
            const filSt = this.gridInfo.fmap.get(this.gridInfo.vars_cSelFilSt),
                  filEd = this.gridInfo.fmap.get(this.gridInfo.vars_cSelFilEd);
            if(!filSt || !filEd) return style;
            const stFirst = filSt.__idx < filEd.__idx;
            const lFil = stFirst ? filSt : filEd,
                  rFil = stFirst ? filEd : filSt;
            // 2.1 Check start/end/selcted
            let stx=lFil.__pox,
                stb=lFil.__pob; // Start 
            let edx=rFil.__pox+(rFil.__width||0),
                edb=rFil.__pob+(rFil.__width?0:1); // End
            let slx=edx-stx,
                slb=edb-stb; // Selected
            // 2.2 And need blank?
            let pCnt=0, pOff=0;
            if(!isScroll) {
                pCnt = COLS.reduce((acc, f)=> acc+(!f.__width&&!f.hide?1:0), 0);
                pOff = COLS.reduce((acc, f)=> acc+(f.hide?1:f.__width), 0);
                if(this.gridInfo.opts.selectCheck) {
                    pOff += this.gridInfo.opts.selectCheckboxWidth
                }
            } else {
                stx+= dWIDTH*stb; stb=0;
                slx+= dWIDTH*slb; slb=0;
                edx+= dWIDTH*edb;
            }
            
            // 3. Adjust freeze
            var underFlag = false;
            var overFlag  = false
            // 4. Set Value
            if(!lFil.__frz) {stx-= SCL}
            else if(lFil.__frz && !rFil.__frz) {slx-= SCL}
            if(!lFil.__frz && stx < FRZ) {
                slx-= FRZ-stx;//keep order
                stx = FRZ;
                overFlag = true;
            }
            if(!lFil.__frz && edx - SCL < FRZ) {
                return {display:'none'}
            }
            if(lFil.__frz && edx > FRZ && edx - SCL < FRZ) {
                underFlag = true;
                slx = FRZ - stx;
            }
            // 4.1 left/width
            
            
            if(stb+slb>0) {
                style.left  = `calc(${100/pCnt*stb}% - ${pOff/pCnt*stb}px + ${stx}px)`;
                style.width = `calc(${100/pCnt*slb}% - ${pOff/pCnt*slb}px + ${slx}px)`;
            } else {
                style.left  = `${stx}px`;
                style.width = `${slx}px`;
            }
            // 4.2 show left border (freezer hide it)
            if(underFlag) {style['border-right'] = 'none'}
            if(overFlag)  {style['border-left'] = 'none'}
            return style;
        },
        // [COMPUTED] Style, Select style
        selectStyle() {
            // 1. Build style
            var style = {}
            // 1.1 display
            style.display = 'block'
            // 1.2 Vertical style(top, height)
            var vStyle = this.verticalStyle;
            style.top    = vStyle.top;
            style.height = vStyle.height;
            // 2.2 Horizontal position(left, width) + Hide border left
            var hStyle = this.horizontalStyle;
            style.left  = hStyle.left;
            style.width = hStyle.width;
            if(hStyle['border-left']) {
                style['border-left'] = hStyle['border-left']
            }
            if(hStyle['border-right']) {
                style['border-right'] = hStyle['border-right']
            }
            if(hStyle['display']) {style['display'] = hStyle['display']}
            // x. return
            return style;
        },
        // [COMPUTED] Style, Highlight for first cell
        /* NOSONAR */firstStyle() {
            /*update flag*/this.recomputed;
            const PAD = 3, BOR = 2;
            const isBDR  = this.gridInfo.opts.styleBordered;
            // 2. Set position
            var pos = {display:'block'}, H = this.gridInfo.opts.rowHeight;
            // 2.1 Calc vertical position(top, height)
            if(this.gridInfo.vars_cSelIdxSt > this.gridInfo.vars_cSelIdxEd) {
                pos.bottom = (0+PAD) + "px";
            } else {
                pos.top    = (0+PAD) + "px";
            }
            pos.height = (H-PAD*2-BOR*2-(isBDR?1:0)) + "px";
            // 2.2 Calc horizontal position(left - width)
            // 2.2.0 Prepare data
            const filSt = this.gridInfo.fmap.get(this.gridInfo.vars_cSelFilSt);
            const filEd = this.gridInfo.fmap.get(this.gridInfo.vars_cSelFilEd);
            if(!filSt || !filEd) return {};
            const stFirst = filSt.__idx <= filEd.__idx;
            const lFil = stFirst ? filSt : filEd,
                  rFil = stFirst ? filEd : filSt;
            
            const dWIDTH = this.gridInfo.opts.defaultFieldWidth;
            const $src = this.gridInfo.refs.scrollWrapper;
            const FRZ  = this.gridInfo.vars_freezeWidth,
                  SRW  = $src.getBoundingClientRect().width,
                  SCL  = $src.scrollLeft;
            const isScroll = SRW+FRZ < this.gridInfo.vars_tableWidth;
            // 2.1 Check start/end/selcted
            let slx=0,slb=0;
            // 2.2.2 Init Size
            if(filSt.__width)   {slx=filSt.__width}
            else if(filSt.__frz){slx=dWIDTH}
            else if(isScroll)   {slx=dWIDTH}
            else                {slb=1}
            // 2.2.3 check scroll
            let off = PAD;
            if(isScroll) {
                let stx = filSt.__pox + dWIDTH*filSt.__pob;
                if(stx-SCL < FRZ && FRZ <= stx) {
                    var dif = FRZ+SCL-stx;
                    slx -= dif-PAD;
                    if(dif < PAD) {off = PAD-(dif)}
                    else {off = 0}
                }
            }
            // 2.2.x Set position
            if(stFirst) {
                pos.left  = off + "px";
            } else {
                pos.right = PAD + "px";
            }
            
            
            let px = 0, pb = 0;
            if(slb) {
                px = rFil.__pox + (rFil.hide?1:rFil.__width||0) - lFil.__pox - filSt.__width;
                pb = rFil.__pob + (rFil.__width||rFil.hide?0:1) - lFil.__pob;
                pos.width = `calc(${100/pb}% - ${px/pb+2*PAD}px)`
            } else {
                px = slx-2*PAD-2*BOR-(isBDR?1:0)
                if(px<0) {px=0}
                pos.width = `${px}px`;
            }
            // x. return
            return pos;
        }
    },
    watch : {
        'gridInfo.vars_cSelIdxEd' : {handler(v,w){
            //this.adjustScrollTop(v);
        }}
    },
    mounted() {
        this.gridInfo.func.setRefs('selectWrapper',this.$refs.selectWrapper);
        this.gridInfo.eventBus.$on('update-cell-select',this.updateHoriStyle)
    },
    methods : {
        // [METHOD] Update selection style
        updateHoriStyle() {
            this.$nextTick(()=> {
                this.recomputed = new Date().getTime();
            })
        }
    }
}

</script>
